module.exports = __webpack_public_path__ + "img/Network_Security@3x.f78c9220.png";